var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotificaitionOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 13.76V10.27C19 6.01 15.78 2.29 11.53 2.02C11.35 2.01 11.17 2 11 2C6.58 2 3 5.58 3 10V13.76C3 15.23 2.66 16.68 2 18H9C9 19.1 9.9 20 11 20C12.1 20 13 19.1 13 18H20C19.34 16.68 19 15.23 19 13.76ZM4.78 16C4.93 15.26 5 14.51 5 13.76V10C5 6.69 7.69 4 11 4C11.13 4 11.27 4 11.4 4.01C14.54 4.21 17 6.96 17 10.27V13.76C17 14.51 17.07 15.26 17.22 16H4.78Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificaitionOff);
export default __webpack_public_path__ + "static/media/icon-notificaition-off.826aa196b522fb384078f51583a717e1.svg";
export { ForwardRef as ReactComponent };